<template>
    <div class="filters">
        <reo-select
            class="reo-select"
            :widthOut="resourceSelectorStyle.widthOut"
            :heightOut="selectorStyle.heightOut"
            :widthIn="resourceSelectorStyle.widthIn"
            :heightIn="selectorStyle.heightIn"
            :selectMarginLeft="selectorStyle.selectMarginLeft"
            :triangleRight="selectorStyle.triangleRight"
            :maxHeight="selectorStyle.maxHeight"
            :fontSizeIn="selectorStyle.fontSizeIn"
            :fontSizeOut="selectorStyle.fontSizeOut"
            :options="firstLevelSelectKeys"
            :defaultSelected="filter_first_current"
            @input="handleFilterFirst"
        />
        <reo-select
            v-if="subOptions"
            class="reo-sub-select"
            :widthOut="resourceSelectorStyle.widthOut"
            :heightOut="selectorStyle.heightOut"
            :widthIn="resourceSelectorStyle.widthIn"
            :heightIn="selectorStyle.heightIn"
            :selectMarginLeft="selectorStyle.selectMarginLeft"
            :triangleRight="selectorStyle.triangleRight"
            :maxHeight="selectorStyle.maxHeight"
            :fontSizeIn="selectorStyle.fontSizeIn"
            :fontSizeOut="selectorStyle.fontSizeOut"
            :options="subOptions"
            :defaultSelected="filter_second_current"
            @input="handleFilterSecond"
        />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoSelect from '@/basic/ReoSelect.vue';

export default Vue.extend({
    name: 'FilterSelector',
    components: {
        ReoSelect,
    },
    props: {
        firstLevelSelectKeys: {
            type: Array,
            required: true,
        },
        filter_first_current: {
            type: String,
            required: true,
        },
        filter_second_current: {
            type: String,
            required: true,
        },
        selectorStyle: {
            type: Object,
            required: true,
        },
        resourceSelectorStyle: {
            type: Object,
            required: true,
        },
        subOptions: {
            type: Array,
            default: null,
        },
    },
    methods: {
        handleFilterFirst( select: string ) {

            this.$emit( 'filter-first', select );

        },
        handleFilterSecond( select: string ) {

            this.$emit( 'filter-second', select );

        },
    },
});
</script>

<style lang="less" scoped>
.filters {
    display: flex;
    justify-content: flex-start;
    gap: 26px;
    @media @mobile {
        width: 100%;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 16px;
    }

    .reo-select {
        min-width: 350px;
    }

    .reo-sub-select {
        min-width: 350px;
    }
}
</style>
